import Vue from 'vue'
import { ValidationProvider, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import { messages } from 'vee-validate/dist/locale/es.json'

// console.log('rules', rules)

Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule] // assign message
  })
})

// Add a personalize rule.
extend('phone', {
  validate: value => value.length === 12,
  message: 'Teléfono no valido'
})

// Register it globally
Vue.component('ValidationProvider', ValidationProvider)
